import { ArrowUpRight, Building2, Factory, HardHat, Hotel, Home, Paintbrush, Plane, Ship, ShieldCheck, Sprout } from "lucide-react";

export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_1b2417f2-a450-4018-84ad-e16255dbd8d1/artifacts/867ug41o_IMG_1771.png";
export const WHATSAPP_URL = "https://wa.me/17215879525?text=Hello%20Sint%20Maarten%20Premier%20Cleaning%2C%20I%20would%20like%20to%20inquire%20about%20your%20luxury%20cleaning%20services.";
export const CONTACT = {
  email: "info@sintmaartenpremiercleaning.com",
  phoneDisplay: "+1 (721) 587-9525",
  phoneHref: "tel:+17215879525",
  location: "Sint Maarten",
};

export const services = [
  {
    id: "residential-cleaning",
    number: "01",
    icon: Home,
    title: "Residential Cleaning",
    short: "A spotless home for you and your family.",
    description: "Deep cleaning, maintenance cleaning, move-in/move-out, and luxury home detailing for the places that matter most.",
    deliverables: ["Deep and maintenance cleaning", "Move-in / move-out handover", "Luxury home detailing"],
    idealFor: "Private homes, villas, and family retreats",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/fb17a9a41627dcbf8a8911511d8013e25146944d14a2c3cf8295f38653dd6e9f.jpeg",
    alt: "Sunlit Caribbean villa living room overlooking the sea",
  },
  {
    id: "hotel-housekeeping",
    number: "02",
    icon: Hotel,
    title: "Hotel & Housekeeping",
    short: "Hospitality shines through cleanliness.",
    description: "Full housekeeping support, room turnaround, lobby detailing, and resort-level standards for every arrival.",
    deliverables: ["Room and suite turnaround", "Lobby and common-area detailing", "Resort-level housekeeping support"],
    idealFor: "Boutique hotels, resorts, and villas",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/5d1cb8cf4068a8a2db36f72796ba49f1aee46452babe079ec306065fcb9d9b52.jpeg",
    alt: "Pristine luxury hotel room with Caribbean balcony view",
  },
  {
    id: "commercial-cleaning",
    number: "03",
    icon: Building2,
    title: "Commercial Cleaning",
    short: "Immaculate spaces that reflect your professionalism.",
    description: "Discreet, reliable care for offices, retail stores, medical facilities, and business centers that cannot miss a detail.",
    deliverables: ["Scheduled office cleaning", "Retail and showroom presentation", "Medical and touchpoint sanitation"],
    idealFor: "Offices, boutiques, clinics, and business centers",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/57da340fb95cfc4844945b01b297de65a9975e07705d34af00ff87832d77359a.jpeg",
    alt: "Polished executive office with glass walls and tropical daylight",
  },
  {
    id: "industrial-cleaning",
    number: "04",
    icon: Factory,
    title: "Industrial Cleaning",
    short: "Powerful cleaning solutions for demanding environments.",
    description: "Heavy-duty cleaning for warehouses, factories, mechanical shops, and facilities where performance and safety come first.",
    deliverables: ["Warehouse and factory floor care", "Mechanical shop degreasing", "Heavy-duty facility sanitation"],
    idealFor: "Warehouses, factories, and mechanical facilities",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/f59a2b5e37e44377e7f3ddaccb7949a00a41b201b2ef3713d6936dd80bb6bc90.jpeg",
    alt: "Bright organized industrial warehouse with polished concrete floor",
  },
  {
    id: "aircraft-cleaning",
    number: "05",
    icon: Plane,
    title: "Aircraft Cleaning",
    short: "Impeccable cleaning at 30,000 feet.",
    description: "Cabin detailing, cockpit cleaning, lavatory sanitation, and turnaround service delivered with aviation-ready precision.",
    deliverables: ["Cabin and leather detailing", "Cockpit dust-free cleaning", "Lavatory sanitation and turnaround"],
    idealFor: "Private aircraft, charter operators, and FBOs",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/0591ec08c0e382852f185dc1baa8eaab8bc137bfe7159e6de905026d844030f5.jpeg",
    alt: "Immaculate private aircraft cabin with cream leather seats",
  },
  {
    id: "yacht-cleaning-detailing",
    number: "06",
    icon: Ship,
    title: "Yacht Cleaning & Detailing",
    short: "Luxury care for your pride on the water.",
    description: "Interior detailing, exterior polishing, deck cleaning, and marine-grade sanitation for yachts at anchor or in turnaround.",
    deliverables: ["Interior and cabin detailing", "Exterior polish and deck care", "Marine-grade sanitation"],
    idealFor: "Yachts, charter vessels, and marina crews",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/9b9d45ca1dd6e6c1903424e66fd6611c20d7203e5282a1df77124e43febff61e.jpeg",
    alt: "Refined yacht salon with teak details and ocean views",
  },
  {
    id: "painting-texture-finishing",
    number: "07",
    icon: Paintbrush,
    title: "Painting, Texture & Finishing",
    short: "Precision, perfection, professional results.",
    description: "Interior and exterior painting, wall textures, finishing, and restoration that bring every architectural surface back to life.",
    deliverables: ["Interior and exterior painting", "Custom wall textures", "Finishing and restoration work"],
    idealFor: "Villas, hospitality spaces, and renovations",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/c3e30c2dafb428b1c521ab7c72e00fd9ccea54ed6019949941c06f6b8c51b2f5.jpeg",
    alt: "Elegant interior painting and finishing tools beside a refined wall",
  },
  {
    id: "sanitization-services",
    number: "08",
    icon: ShieldCheck,
    title: "Sanitization Services",
    short: "Disinfection you can trust for a safer, healthier environment.",
    description: "Hospital-grade sanitization for homes, businesses, and public spaces, handled carefully and communicated clearly.",
    deliverables: ["High-touch surface disinfection", "Home and business sanitization", "Health-conscious cleaning protocols"],
    idealFor: "Homes, businesses, and public spaces",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/6ba2b20447d1885c1b2cff7330e2421afb50c04491ea60db7b1ae371f939b8af.jpeg",
    alt: "Professional sanitizing a marble counter in a bright Caribbean home",
  },
  {
    id: "post-construction-cleaning",
    number: "09",
    icon: HardHat,
    title: "Post-Construction Cleaning",
    short: "Removing dust so you can enjoy the results.",
    description: "Debris removal, dust elimination, polishing, and final presentation cleaning after a build, renovation, or handover.",
    deliverables: ["Debris and fine-dust removal", "Glass, tile, and surface polish", "Final presentation cleaning"],
    idealFor: "Builders, designers, and new property owners",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/bf2ece11e4a0077e5aa09e60ab6d8ab045d9dbe16e5e7d05fd1822c471a8ab78.jpeg",
    alt: "Newly finished luxury interior being prepared for presentation",
  },
  {
    id: "landscaping",
    number: "10",
    icon: Sprout,
    title: "Landscaping",
    short: "Design, enhancement, and maintenance of inspiring landscapes.",
    description: "Lawn care, garden design, trimming, planting, and outdoor beautification for a first impression that lasts.",
    deliverables: ["Lawn and garden maintenance", "Trimming and planting", "Outdoor beautification and design"],
    idealFor: "Private estates, resorts, and commercial grounds",
    image: "https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/6bc4ffef7f480e803959ebcd800132e1c1a632e8ea9ccc46ece2a1979c25a7d9.jpeg",
    alt: "Sculptural tropical garden surrounding a modern Caribbean villa",
  },
];

export const premierReasons = [
  { number: "01", title: "Highly trained professionals", text: "Trusted people, carefully trained to move through your environment with care and confidence." },
  { number: "02", title: "Eco-conscious products", text: "Safe, considered formulas chosen for people, pets, finishes, and the island we call home." },
  { number: "03", title: "On-time reliability", text: "A clear arrival window, quiet execution, and a standard that does not drift with the schedule." },
  { number: "04", title: "Luxury-grade results", text: "The difference is in the final five percent: edges, touchpoints, scent, and the feeling of order." },
  { number: "05", title: "Transformation guaranteed", text: "We do not just clean — we transform every environment we are trusted to enter." },
];

export const manifestoChapters = [
  { number: "01", title: "The island is the brief", text: "Salt air, tropical humidity, bright sun, and beautiful materials demand more than a standard checklist. Our care is shaped for Sint Maarten." },
  { number: "02", title: "Precision is hospitality", text: "A clean room is not the finish line. It is the quiet foundation for a welcome, a handover, a flight, or an evening at home." },
  { number: "03", title: "Discretion is part of service", text: "We work with respect for your privacy, your property, and the people who trust you to keep both protected." },
  { number: "04", title: "The final look matters", text: "Every assignment ends with a visual reset: surfaces aligned, details resolved, and an environment ready to be lived in." },
];

// Placeholder testimonials — replace quote, name, and title with real client words.
export const testimonials = [
  {
    id: "testimonial-villa",
    quote: "From the first walkthrough to the final reveal, the villa felt entirely new. Every surface, every edge, every detail — resolved without us ever having to ask.",
    name: "Private Villa Owner",
    title: "Terres Basses / Lowlands",
  },
  {
    id: "testimonial-yacht",
    quote: "Turnarounds at the dock are unforgiving, and this team has never missed one. The interior comes back charter-ready, quietly and precisely, every single time.",
    name: "Yacht Captain",
    title: "Simpson Bay Marina",
  },
  {
    id: "testimonial-hotel",
    quote: "Our guests notice the difference before they can name it. Working with Premier Cleaning raised our housekeeping standard to the level our property deserves.",
    name: "General Manager",
    title: "Boutique Resort, Cupecoy",
  },
];

export const serviceAreas = [
  "Terres Basses / Lowlands",
  "Simpson Bay & Isle de Sol",
  "Cupecoy & Porto Cupecoy",
  "Guana Bay & Dawn Beach",
  "Oyster Pond & Pelican Key",
  "Indigo Bay & Beacon Hill",
  "Princess Juliana International (SXM)",
];

export const quoteOptions = {
  propertyTypes: ["Private villa / estate", "Hotel / hospitality property", "Commercial space", "Industrial facility", "Aircraft / FBO", "Yacht / marine vessel", "Outdoor grounds"],
  locations: ["Terres Basses / Lowlands", "Simpson Bay & Isle de Sol", "Cupecoy / Porto Cupecoy", "Guana Bay / Dawn Beach", "Philipsburg / Indigo Bay", "Other Sint Maarten location"],
  preferredWindows: ["As soon as possible", "Within the next 7 days", "Within the next 30 days", "Planning ahead"],
};

export const ArrowIcon = ArrowUpRight;
